module.exports = __webpack_public_path__ + "static/feather2_maroon-0df0893fa84b7c11f1abb3ea6b36e83a.png";